import React, {PropTypes, Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {SketchPicker} from 'react-color'
import RemoveModalDialog from'shared/RemoveModalDialog';
import Select   from 'react-select'
import {MAP} from 'react-google-maps/lib/constants';

import {makeRequest, displayMessage}  from 'actions';
import GoogleMapComponent from 'shared/GoogleMapComponent'
import FaTimesCircle from 'react-icons/lib/fa/times-circle';
import {FieldGroup} from 'react-bootstrap';
 import {Col, Row, FormControl, Button, Checkbox} from 'react-bootstrap';
import {v4 as uuidv4}  from 'uuid'
import config from  '../../../config';
var timeWindowSelectOptions = [
    {'label': '8am - 5pm', disabled: false, 'value': '8_17'},
    {'label': '8am - 10am', disabled: false, 'value': '8_10'},
    {'label': '10am - 12pm', disabled: false, 'value': '10_12'},
    {'label': '12pm - 2pm', disabled: false, 'value': '12_14'},
    {'label': '2pm - 4pm', disabled: false, 'value': '14_16'},
    {'label': '4pm - 6pm', disabled: false, 'value': '16_18'},
    {'label': '6pm - 8pm', disabled: false, 'value': '18_20'},
]




class ServiceAreasSettingsPage extends Component {
    static contextTypes = {[MAP]: PropTypes.object};

    constructor(props, context) {
        console.log('in service');
        super(props, context);
        this.state = {
            polygonsHasBeenDrawn: false,
            center: config.maps.defaultCoordinates,
            displayColorPicker: false,
            currentItemID: false,
            selectedLocation: false,
            serviceAreas: [],
            removeRecordModalVisible: false,

        }
        this.displayZonesWherePointLocated = this.displayZonesWherePointLocated.bind(this)
    };


    fetchPolygons() {
        var methodData = {
            "endpoint": "/service_areas"
        };
        this.props.makeRequest({}, methodData)
            .then(function (res) {
                if (this._drawingMap && !this.state.polygonsHasBeenDrawn) {
                    var serviceAreasWithPolygons = []
                    this.setState({polygonsHasBeenDrawn: true})
                    _.forEach(res.data.data, function (serviceArea, index) {
                        var polygon = new google.maps.Polygon({
                            // paths: _.map(serviceArea.Area, function (path) {
                            //     return {lat: path.coordinates[0], lng: path.coordinates[1]}
                            // }),
                            paths: _.map(serviceArea.Area.coordinates, function (coordinate) {
                                return {lat: coordinate[1], lng: coordinate[0]}
                            }),
                            fillColor: serviceArea.Color,
                            strokeColor: serviceArea.Color,
                            editable: true,
                            draggable: true,
                            strokeWeight: 1,
                            strokeOpacity: 0.5,
                            zIndex: serviceArea.Priority,
                         });
                        google.maps.event.addListener(polygon.getPath(), 'set_at', this._getPolygonNewPaths.bind(polygon, this));
                        google.maps.event.addListener(polygon.getPath(), 'insert_at', this._getPolygonNewPaths.bind(polygon, this));
                        google.maps.event.addListener(polygon.getPath(), 'remove_at', this._getPolygonNewPaths.bind(polygon, this));
                        google.maps.event.addListener(polygon, 'click', this.onPolygonClickHandler.bind(this, serviceArea));
                        google.maps.event.addListener(polygon, 'rightclick', this.onPolygonRightClickHandler.bind(this));
                        polygon.setMap(this._drawingMap.context[MAP]);
                        serviceArea.polygonOnMap = polygon;
                        serviceArea.ServiceTimes = _.map(serviceArea.ServiceTimes, function (serviceTime) {
                            return {label:_.find(timeWindowSelectOptions, {value:serviceTime.value}).label, value:serviceTime.value}
                        })
                        serviceArea.MarketName = {value:serviceArea.MarketName,label:serviceArea.MarketName}
                        serviceAreasWithPolygons.push(serviceArea)
                    }.bind(this))
                    this.setState({
                        serviceAreas: serviceAreasWithPolygons,
                        currentItemID: serviceAreasWithPolygons[0]._id
                    })
                    serviceAreasWithPolygons[0].polygonOnMap.setOptions({
                        options: {
                            strokeWeight: 3,
                            strokeOpacity: 1,
                            zIndex: 1000,
                        }
                    })
                }
            }.bind(this)).catch(err => {

        });
    }

    handleOnMapLoad(_drawingMap) {
        if (_drawingMap && !this._drawingMap) {
            this._drawingMap = _drawingMap;
            this.fetchPolygons();
        }
    }

    _getPolygonNewPaths(component, index, object) {
        let polygonPaths = []
        this.getPath().getArray().forEach((path, index) => {
            // console.log('Coordinate', index + ' ' + path.lat() + ',' + path.lng());
            const line = {
                lat: path.lat(),
                lng: path.lng()
            }
            polygonPaths.push(line)
        })
    }

    changeCurrentServiceArea(currentZone) {
        console.log('changeCurrentServiceArea', currentZone);
        if (currentZone) {
            _.forEach(this.state.serviceAreas, function (item, index) {
                item.polygonOnMap.setOptions({options: {strokeWeight: 1, strokeOpacity: 0.5, zIndex: item.Priority}})
            });
            this.setState({currentItemID: currentZone._id})
            currentZone.polygonOnMap.setOptions({
                options: {
                    strokeWeight: 3,
                    strokeOpacity: 1,
                    zIndex: 1000
                }
            })
        } else {
            this.setState({currentItemID: false})
        }
    }

    onPolygonClickHandler(serviceArea, polygon, event) {
        this.changeCurrentServiceArea(serviceArea);
    }

    onPolygonRightClickHandler(event) {
        this.setState({
            selectedLocation: {
                position: event.latLng,
                defaultAnimation: 2,
                key: Date.now(), // Add a key property for: http://fb.me/react-warning-keys
            },
        });
    }

    handleMapRightClick(event) {
        this.setState({
            selectedLocation: {
                position: event.latLng,
                defaultAnimation: 2,
                key: Date.now(), // Add a key property for: http://fb.me/react-warning-keys
            },
        });
    }


    addNewServiceArea() {
        if (this._drawingMap) {
            var polygon = new google.maps.Polygon({
                paths: config.maps.defaultPolygonCoordinates,
                fillColor: 'green',
                strokeColor: 'green',
                editable: true,
                draggable: true
            });
            var newServiceArea = {
                _id: uuidv4(),
                Color: 'green',
                newItem: true,
                Name: '',
                Upcharge: '',
                DaysOfWeek: []
            };
            google.maps.event.addListener(polygon.getPath(), 'set_at', this._getPolygonNewPaths.bind(polygon, this));
            google.maps.event.addListener(polygon.getPath(), 'insert_at', this._getPolygonNewPaths.bind(polygon, this));
            google.maps.event.addListener(polygon.getPath(), 'remove_at', this._getPolygonNewPaths.bind(polygon, this));
            google.maps.event.addListener(polygon, 'click', this.onPolygonClickHandler.bind(this, newServiceArea));
            google.maps.event.addListener(polygon, 'rightclick', this.onPolygonRightClickHandler.bind(this));

            polygon.setMap(this._drawingMap.context[MAP]);
        }
        newServiceArea.polygonOnMap = polygon;
        this.setState({
            serviceAreas: [...this.state.serviceAreas, newServiceArea]
        });
        this.changeCurrentServiceArea(newServiceArea);
    }

    deleteServiceArea() {
        var itemIndex = _.findIndex(this.state.serviceAreas, function (record) {
            return this.state.currentItemID == record._id;
        }.bind(this));
        if ( this.state.serviceAreas[itemIndex].newItem) {
            this.state.serviceAreas[itemIndex].polygonOnMap.setMap(null);
            this.setState({
                currentItemID: false,
                removeRecordModalVisible: false,
                serviceAreas: [...this.state.serviceAreas.slice(0, itemIndex),
                    ...this.state.serviceAreas.slice(itemIndex + 1)]
            }, function () {
                /* set the latest element as current */
                this.changeCurrentServiceArea(this.state.serviceAreas[this.state.serviceAreas.length - 1] ? this.state.serviceAreas[this.state.serviceAreas.length - 1] : false);
            }.bind(this));

        } else {


            var methodData = {
                endpoint: '/service_areas',
                messageData: {'#1#': 'Service area'},
                messageCode: 'recordDeleted',
                type: 'delete'
            }

            this.props.makeRequest({id: this.state.serviceAreas[itemIndex]._id}, methodData).then(function (response) {
                this.state.serviceAreas[itemIndex].polygonOnMap.setMap(null);
                console.log('this.state.serviceAreas[itemIndex]', this.state.serviceAreas[itemIndex]);
                this.setState({
                    currentItemID: false,
                    removeRecordModalVisible: false,
                    serviceAreas: [...this.state.serviceAreas.slice(0, itemIndex),
                        ...this.state.serviceAreas.slice(itemIndex + 1)]
                }, function () {
                    this.changeCurrentServiceArea(this.state.serviceAreas[this.state.serviceAreas.length - 1] ? this.state.serviceAreas[this.state.serviceAreas.length - 1] : false);
                }.bind(this));
            }.bind(this))
        }

    }

    hideNotValidFieldError(selectedItem, field) {
        var itemIndex = _.findIndex(this.state.serviceAreas, function (record) {
            return selectedItem._id == record._id;
        });
        this.changeCurrentServiceArea(this.state.serviceAreas[itemIndex]);
        this.setState({
            serviceAreas: [...this.state.serviceAreas.slice(0, itemIndex),
                {...this.state.serviceAreas[itemIndex], [field]: false},
                ...this.state.serviceAreas.slice(itemIndex + 1)]
        });
    }

    onZoneFieldChange(selectedItem, field, e) {
        var itemIndex = _.findIndex(this.state.serviceAreas, function (item) {
            return selectedItem._id == item._id;
        });
        this.changeCurrentServiceArea(this.state.serviceAreas[itemIndex]);
        this.setState({
            serviceAreas: [...this.state.serviceAreas.slice(0, itemIndex),
                {...this.state.serviceAreas[itemIndex], [field]: e.target.value},
                ...this.state.serviceAreas.slice(itemIndex + 1)]
        });
    }

    onColorChange(currentItem, color, event) {
        var itemIndex = _.findIndex(this.state.serviceAreas, function (item) {
            return currentItem._id == item._id;
        });
        this.state.serviceAreas[itemIndex].polygonOnMap.setOptions({
            options: {
                'fillColor': color.hex,
                strokeColor: color.hex
            }
        })
        this.setState({
            serviceAreas: [...this.state.serviceAreas.slice(0, itemIndex),
                {...this.state.serviceAreas[itemIndex], Color: color.hex},
                ...this.state.serviceAreas.slice(itemIndex + 1)]
        });

    }

    // AvailableCarsSelectLabelRender(option) {
    //      return <div  >{option.label + ' ' + option.Number}</div>
    // }
    //
    // onAvailableCarLabelClick(currentItem, option) {
    //     var itemIndex = _.findIndex(this.state.serviceAreas, function (item) {
    //         return currentItem._id == item._id;
    //     });
    //     var AvailableCars = [..._.get(this.state.serviceAreas[itemIndex], ['AvailableCars'], [])]
    //     var selectedCarTypeInState = _.find(AvailableCars, function (selectedOption) {
    //         return selectedOption.value == option.value
    //     })
    //     selectedCarTypeInState.Number++
    //     this.setState({
    //         serviceAreas: [...this.state.serviceAreas.slice(0, itemIndex),
    //             {...this.state.serviceAreas[itemIndex], AvailableCars: AvailableCars},
    //             ...this.state.serviceAreas.slice(itemIndex + 1)]
    //     });



    // onAvailableCarTypeChange(currentItem, options) {
    //     var itemIndex = _.findIndex(this.state.serviceAreas, function (item) {
    //         return currentItem._id == item._id;
    //     });
    //     var AvailableCars = [..._.get(this.state.serviceAreas[itemIndex], ['AvailableCars'], [])]
    //     if (options.length > AvailableCars.length) { /* when new option is selected */
    //         AvailableCars.push({... _.last(options), Number: 1})
    //
    //     } else if (options.length < AvailableCars.length) { /* value is removed */
    //         var deletedOption = _.differenceWith(AvailableCars, options, function (item1, item2) {
    //             return item1.value === item2.value;
    //         });
    //         var selectedCarTypeInState = _.find(AvailableCars, function (selectedOption) {
    //             return selectedOption.value == deletedOption[0].value
    //         })
    //         if (selectedCarTypeInState.Number == 1) {
    //             _.pull(AvailableCars, selectedCarTypeInState)
    //         } else {
    //             selectedCarTypeInState.Number--
    //         }
    //     }
    //
    //     this.setState({
    //         serviceAreas: [...this.state.serviceAreas.slice(0, itemIndex),
    //             {...this.state.serviceAreas[itemIndex], AvailableCars: AvailableCars},
    //             ...this.state.serviceAreas.slice(itemIndex + 1)]
    //     });
    //
    // }

    onDayOfWeekChange(selectedItem, dayOfWeek, e) {
        var itemIndex = _.findIndex(this.state.serviceAreas, function (item) {
            return selectedItem._id === item._id;
        });
        this.changeCurrentServiceArea(this.state.serviceAreas[itemIndex]);
        if (!e.target.previousElementSibling.checked) {
            var updatedValue = _.uniq([...this.state.serviceAreas[itemIndex].DaysOfWeek, dayOfWeek]);
        } else {
            var updatedValue = _.pull([...this.state.serviceAreas[itemIndex].DaysOfWeek], dayOfWeek)
        }

        this.setState({
            serviceAreas: [...this.state.serviceAreas.slice(0, itemIndex),
                {...this.state.serviceAreas[itemIndex], DaysOfWeek: updatedValue},
                ...this.state.serviceAreas.slice(itemIndex + 1)]
        });
    }

    toggleDisplayColorPicker(selectedItem) {
        this.setState({displayColorPicker: !this.state.displayColorPicker})
        this.changeCurrentServiceArea(selectedItem);
    };

    displayZonesWherePointLocated() {
        if (this._drawingMap && this.state.selectedLocation) {
            var serviceAreasFound = _.map(_.filter(this.state.serviceAreas, function (serviceArea) {
                if (google.maps.geometry.poly.containsLocation(this.state.selectedLocation.position, serviceArea.polygonOnMap)) {
                    return true
                }
            }.bind(this)), function (serviceAreaFound, index) {
                return {
                    'Name': serviceAreaFound.Name,
                    Color: serviceAreaFound.Color,
                    index: index,
                    _id: serviceAreaFound._id
                }
            }.bind(this))
            if (_.size(serviceAreasFound) == 0) {
                return (<span>No zone is defined for this address</span>)
            } else {
                return _.map(serviceAreasFound, function (serviceArea) {
                    return (<div>
                        <span className="right5"> Results:</span>
                        <span className="right10"
                              style={{'color': serviceArea.Color}}>{serviceArea.Name ? +serviceArea.Name : 'Service Area ' + (serviceArea.index + 1)}</span>
                    </div>)
                })
            }

        } else {
            return null;
        }
    }
    onServiceTimesChange(currentItem, selectedOptions ) {
        var itemIndex = _.findIndex(this.state.serviceAreas, function (item) {
            return currentItem._id == item._id;
        });
        this.setState({
            serviceAreas: [...this.state.serviceAreas.slice(0, itemIndex),
                {...this.state.serviceAreas[itemIndex], ServiceTimes: selectedOptions},
                ...this.state.serviceAreas.slice(itemIndex + 1)]
        });
    }

    createJSTSPolygon(geometryFactory, polygon) {
        var path = polygon.getPath();
        var coordinates = path.getArray().map(function name(coord) {
            return new jsts.geom.Coordinate(coord.lat(), coord.lng());
        });
        if (coordinates[0].compareTo(coordinates[coordinates.length - 1]) != 0)
            coordinates.push(coordinates[0]);
        var shell = geometryFactory.createLinearRing(coordinates);
        return geometryFactory.createPolygon(shell);
    }
    // checkIfPolygonsIntersects() {
    //     var JSTSPolygons = [], self = this, polygonsIntersect = false;
    //     _.forEach(self.state.serviceAreas, function (serviceArea) {
    //         var geometryFactory = new jsts.geom.GeometryFactory();
    //         JSTSPolygons.push(self.createJSTSPolygon(geometryFactory, serviceArea.polygonOnMap));
    //     })
    //
    //     _.forEach(JSTSPolygons, function (polygonToCheck, outerIndex) {
    //         if (polygonsIntersect) {
    //             return false;
    //         }
    //         _.forEach(JSTSPolygons, function (polygon, innerIndex) {
    //             if (outerIndex == innerIndex) {
    //                 return true;
    //             }
    //             var intersection = polygonToCheck.intersection(polygon);
    //             console.log('intersection', intersection);
    //             if (intersection.getCoordinates().length > 0) {
    //                 self.props.displayMessage({
    //                     'messageType': 'warning',
    //                     'messageCode': (self.state.serviceAreas[outerIndex].Name !== '' ? self.state.serviceAreas[outerIndex].Name : 'Zone ' + outerIndex) + ' and ' + (self.state.serviceAreas[innerIndex].Name !== '' ? self.state.serviceAreas[innerIndex].Name : 'Zone ' + innerIndex) + ' are overlapping'
    //                 });
    //                 polygonsIntersect = true;
    //                 return false;
    //             }
    //
    //         });
    //     });
    //     return polygonsIntersect;
    //
    // }
    saveServiceAreas() {

        // if (this.checkIfPolygonsIntersects()) {
        //     return;
        // }
       var ServiceAreasPriorities = [],   error= false;
        _.forEach(this.state.serviceAreas, function (serviceAreaToSave) {
            if (!serviceAreaToSave.Priority){
                this.props.displayMessage({
                    'messageType': 'warning',
                    'messageCode': 'errorFieldRequired',
                    'messageData': {'#1#': 'Priority'},
                });
                error = true;
                return false;
            } else    if (isNaN(serviceAreaToSave.Priority)) {
                this.props.displayMessage({
                    'messageType': 'warning',
                    'messageCode':  'Priority ' + serviceAreaToSave.Priority + ' is not a number'
                 });
                error = true;
                return false;
            } else    if(serviceAreaToSave.Priority <=0) {
                this.props.displayMessage({
                    'messageType': 'warning',
                    'messageCode':  'Priority number must be greater than 0'
                });
                error = true;
                return false;
            }
            ServiceAreasPriorities.push(parseInt(serviceAreaToSave.Priority))
        }.bind(this))
        if (_.uniq(ServiceAreasPriorities).length !==ServiceAreasPriorities.length){
            return this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'errorNotUnique',
                'messageData': {'#1#': 'Priority numbers are'}
            });
        }
        if (error){
            return;
        }
        _.forEach(this.state.serviceAreas, function (serviceAreaToSave, itemIndex) {
            var formData = _.pick(serviceAreaToSave, ['Color',  'Name', 'ServiceTimes', 'DaysOfWeek'])
            formData.MarketName = _.get(serviceAreaToSave,'MarketName.value','')
            formData.Priority =     parseInt(serviceAreaToSave.Priority)
            if (formData.ServiceTimes.length == 0) {
                this.props.displayMessage({
                    'messageType': 'warning',
                    'messageCode': 'errorAtLeastOneRequired',
                    'messageData': {'#1#': 'serviceTime'},
                });
                return false;
            }

            if (formData.DaysOfWeek.length == 0) {
                this.props.displayMessage({
                    'messageType': 'warning',
                    'messageCode': 'errorAtLeastOneRequired',
                    'messageData': {'#1#': 'day of week'},
                });
                return false;
            }

            if (formData.Name == '') {
                this.setState({
                    serviceAreas: [...this.state.serviceAreas.slice(0, itemIndex),
                        {...this.state.serviceAreas[itemIndex], 'NameNotValid': true},
                        ...this.state.serviceAreas.slice(itemIndex + 1)]
                });
                this.props.displayMessage({
                    'messageType': 'warning',
                    'messageCode': 'errorFieldRequired',
                    'messageData': {'#1#': 'Name'},
                });
                return false;
            }
            if (!formData.MarketName ) {
                this.props.displayMessage({
                    'messageType': 'warning',
                    'messageCode': 'errorFieldRequired',
                    'messageData': {'#1#': 'Market Name'},
                });
                return false;
            }
            if (formData.Upcharge === '') {
                this.setState({
                    serviceAreas: [...this.state.serviceAreas.slice(0, itemIndex),
                        {...this.state.serviceAreas[itemIndex], 'UpchargeNotValid': true},
                        ...this.state.serviceAreas.slice(itemIndex + 1)]
                });
                this.props.displayMessage({
                    'messageType': 'warning',
                    'messageCode': 'errorFieldRequired',
                    'messageData': {'#1#': 'Upcharge'},
                });
                return false;
            }
            formData.Area = {coordinates: []};
            var firstPoint = false
            serviceAreaToSave.polygonOnMap.getPath().getArray().forEach((path, index) => {
                if (index == 0) {
                    firstPoint = [
                        path.lng(),
                        path.lat()
                    ]
                }
                formData.Area.coordinates.push([
                    path.lng(),
                    path.lat()
                ]);
            })
            if (firstPoint) {
                formData.Area.coordinates.push(firstPoint);
            }


            if (!_.isUndefined(serviceAreaToSave.newItem) && serviceAreaToSave.newItem) {
                var methodData = {
                    messageData: {'#1#': 'Service Area ' + serviceAreaToSave.Name},
                    messageCode: 'recordAdded',
                    endpoint: '/service_areas',
                    type: 'post'
                }
                this.props.makeRequest(formData, methodData).then(function (response) {
                    this.setState({
                        currentItemID: response.data._id,
                        serviceAreas: [...this.state.serviceAreas.slice(0, itemIndex),
                            {...this.state.serviceAreas[itemIndex], _id: response.data._id, 'newItem': false},
                            ...this.state.serviceAreas.slice(itemIndex + 1)]
                    }, function () {
                        google.maps.event.clearListeners(this.state.serviceAreas[itemIndex].polygonOnMap, 'click');
                        google.maps.event.addListener(this.state.serviceAreas[itemIndex].polygonOnMap, 'click', this.onPolygonClickHandler.bind(this, this.state.serviceAreas[itemIndex]));
                    }.bind(this));
                }.bind(this))
            } else {
                var methodData = {
                    messageData: {'#1#': 'Service Area ' + serviceAreaToSave.Name},
                    messageCode: 'recordUpdated',
                    endpoint: '/service_areas',
                    type: 'patch'
                }
                formData.id = serviceAreaToSave._id
                this.props.makeRequest(formData, methodData).then(function (response) {


                }.bind(this))
            }
        }.bind(this))


    }

    handleSearchBoxMounted(searchBox) {
        this._searchBox = searchBox;
    }

    handlePlacesChanged() {
        const places = this._searchBox.getPlaces();
        if (places.length > 0) {
            this.setState({
                center: places[0].geometry.location,
                selectedLocation: {
                    position: places[0].geometry.location,
                    defaultAnimation: 2,
                    key: Date.now(), // Add a key property for: http://fb.me/react-warning-keys
                }
            });
        }
    }

    handleClose = () => {
        this.setState({displayColorPicker: false})
    };

    renderServiceAreaSettings() {
         return _.map(this.state.serviceAreas, function (item, index) {
              return (<Row
                className={'pleft15 service-area ' + (this.state.currentItemID == item._id ? '--activeItem pright0' : 'pright15')}
                style={(this.state.currentItemID === item._id ? {
                    'borderColor': item.Color,
                    'width': 'calc(100% + 15px)'
                } : {})} key={item._id}>
                <Col xs={12}>
                    <Row>
                        <Col className="service-area__color-column" xs={2}>
                            <div>
                                <div style={{'backgroundColor': item.Color}} className={'service-area__color-input'}
                                     onClick={ this.toggleDisplayColorPicker.bind(this, item) }>

                                </div>
                                { this.state.displayColorPicker && this.state.currentItemID == item._id ? <div  >
                                    <div style={{
                                        position: 'fixed',
                                        top: '0px',
                                        right: '0px',
                                        bottom: '0px',
                                        left: '0px'
                                    }
                                    } onClick={ this.toggleDisplayColorPicker.bind(this, item) }/>
                                    <SketchPicker color={ item.Color } onChange={this.onColorChange.bind(this, item) }/>
                                </div> : null }

                            </div>
                        </Col>
                        <Col xs={6} lg={3} className="pleft5">
                            <FormControl type="text"
                                         onFocus={this.hideNotValidFieldError.bind(this, item, 'NameNotValid') }
                                         style={ !_.isUndefined(item.NameNotValid) && item.NameNotValid ? {border: '1px solid red'} : {} }
                                         onChange={this.onZoneFieldChange.bind(this, item, 'Name')}
                                         placeholder="Name"
                                         defaultValue={item.Name}
                            />
                        </Col>
                        <Col style={{width:80}} xs={6} lg={1} className="pleft5">
                            <FormControl type="number"
                                         onFocus={this.hideNotValidFieldError.bind(this, item, 'PriorityNotValid') }
                                          onChange={this.onZoneFieldChange.bind(this, item, 'Priority')}
                                          defaultValue={item.Priority}
                            />
                        </Col>
                        {_.size(_.intersection(_.get(this.props, 'userReducer.user.Roles', []), [  'Administrator'])) > 0 &&

                        <Col xs={4} lg={1} className="top3">

                        <span >
                            <FaTimesCircle className="deleteButton"
                                           onClick={(e) => this.setState({
                                               currentItemID: item._id,
                                               removeRecordModalVisible: true
                                           })}></FaTimesCircle>
                        </span>
                        </Col>
                        }
                        <Col  xs={12} lg={4} className="service-area__checkbox-row">
                            <div className={'checkbox-wrap top10'}>
                                <span style={{  right:12}}>M</span>
                                <input className="styled-checkbox"
                                       checked={_.includes(item.DaysOfWeek, 2)}
                                       onChange={_.noop}
                                       onKeyPress={(e) => {
                                           if (e.which === 13) {
                                               this.onDayOfWeekChange(item, 2, e)
                                           }
                                       } }
                                       type="checkbox"/>
                                <label onClick={this.onDayOfWeekChange.bind(this, item, 2)}/>
                            </div>
                            <div className={'checkbox-wrap top10'}>
                                <span style={{  right: 16}}>T</span>
                                <input className="styled-checkbox"
                                       checked={_.includes(item.DaysOfWeek, 3)}
                                       onChange={_.noop}
                                       onKeyPress={(e) => {
                                           if (e.which === 13) {
                                               this.onDayOfWeekChange(item, 3, e)
                                           }
                                       } }
                                       type="checkbox"/>
                                <label onClick={this.onDayOfWeekChange.bind(this, item, 3)}/>
                            </div>
                            <div className={'checkbox-wrap top10'}>
                                <span style={{  right: 12}}>W</span>
                                <input className="styled-checkbox"
                                       checked={_.includes(item.DaysOfWeek, 4)}
                                       onChange={_.noop}
                                       onKeyPress={(e) => {
                                           if (e.which === 13) {
                                               this.onDayOfWeekChange(item, 4, e)
                                           }
                                       } }
                                       type="checkbox"/>
                                <label onClick={this.onDayOfWeekChange.bind(this, item, 4)}/>
                            </div>
                            <div className={'checkbox-wrap top10'}>
                                <span style={{  right: 10}}>TH</span>
                                <input className="styled-checkbox"
                                       checked={_.includes(item.DaysOfWeek, 5)}
                                       onKeyPress={(e) => {
                                           if (e.which === 13) {
                                               this.onDayOfWeekChange(item, 5, e)
                                           }
                                       } }
                                       onChange={_.noop}
                                       type="checkbox"/>
                                <label onClick={this.onDayOfWeekChange.bind(this, item, 5)}/>
                            </div>
                            <div className={'checkbox-wrap top10'}>
                                <span style={{  right: 16}}>F</span>
                                <input className="styled-checkbox"
                                       checked={_.includes(item.DaysOfWeek, 6)}
                                       onKeyPress={(e) => {
                                           if (e.which === 13) {
                                               this.onDayOfWeekChange(item, 6, e)
                                           }
                                       } }
                                       type="checkbox"/>
                                <label onClick={this.onDayOfWeekChange.bind(this, item, 6)}/>
                            </div>
                            <div className={'checkbox-wrap top10'}>
                                <span style={{  right: 16}}>S</span>
                                <input className="styled-checkbox"
                                       checked={_.includes(item.DaysOfWeek, 7)}
                                       onKeyPress={(e) => {
                                           if (e.which === 13) {
                                               this.onDayOfWeekChange(item, 7, e)
                                           }
                                       } }
                                       type="checkbox"/>
                                <label onClick={this.onDayOfWeekChange.bind(this, item, 7)}/>
                            </div>
                            <div className={'checkbox-wrap top10'}>
                                <span style={{  right: 10}}>SU</span>
                                <input className="styled-checkbox"
                                       checked={_.includes(item.DaysOfWeek, 1)}
                                       onKeyPress={(e) => {
                                           if (e.which === 13) {
                                               this.onDayOfWeekChange(item, 1, e)
                                           }
                                       } }
                                       type="checkbox"/>
                                <label onClick={this.onDayOfWeekChange.bind(this, item, 1)}/>
                            </div>
                        </Col>

                        <Col md={6} sm={8} xs={10} className="pleft0 top10 bot20">
                            <Select
                                tabIndex="0"
                                 style={{marginTop: 10}}
                                clearable={false}
                                searchable={false}
                                selectedOptions
                                 options={   _.map(config.warehouseData, item => {
                                    return {value: item.MarketName, label: item.MarketName}
                                })}
                                onChange={ (option) => {
                                    this.onZoneFieldChange(item, 'MarketName', {target:{value: option ? option : false}})
                                }}
                                 placeholder="Market Name"
                                  value={item.MarketName}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6} sm={8} xs={10} className="pleft0 top10 bot20">
                            <Select
                                clearable={false}
                                placeholder="Service time"
                                multi
                                options={ timeWindowSelectOptions}
                                onChange={(options) => this.onServiceTimesChange(item, options)}
                                value={ _.get(item, ['ServiceTimes'], [])}
                            />
                        </Col>

                    </Row>
                </Col>

            </Row> )
        }.bind(this));
    }

    render() {
        console.log('this.state', this.state);
         return (
            <div className="top20 service-areas-settings-page">
                <h4 className="top20   bold">Service Areas
                </h4>

                <Row>
                    <Col xs={12}  >
                        <GoogleMapComponent
                            center={this.state.center}
                            onMapLoad={this.handleOnMapLoad.bind(this)}
                            markers={this.state.selectedLocation ? [this.state.selectedLocation] : []}
                            onMarkerRightClick={(e) => this.setState({
                                selectedLocation: false
                            })}
                            containerElement={
                                <div style={{height: "400px"}}/>
                            }
                            onMapRightClick={this.handleMapRightClick.bind(this)}
                            onSearchBoxMounted={this.handleSearchBoxMounted.bind(this)}
                            onPlacesChanged={this.handlePlacesChanged.bind(this)}
                            mapElement={
                                <div style={{height: "400px"}}/>
                            }/>
                        <div className="location-zone-match-box">
                            {this.displayZonesWherePointLocated()}
                        </div>
                    </Col>
                    <Col xs={12}   className="top20 " sm={12}>
                        {_.size(_.intersection(_.get(this.props, 'userReducer.user.Roles', []), ['Administrator'])) > 0 &&

                        <Row >
                            <Button onClick={  (e) => this.addNewServiceArea()}
                                    className="pull-right right15 btn btn-primary"
                                    type="button">
                                Add Area
                            </Button>
                        </Row>
                        }
                        <Row className="clearfix top5 right0 left0" style={{'borderTop': '1px solid black'}}></Row>

                        <Col xs={12} className="top5 pright0">
                            {this.renderServiceAreaSettings()}
                        </Col>


                    </Col>
                    <Col xs={12} className="top10   bot20">

                        <Button onClick={this.saveServiceAreas.bind(this)} className="pull-right btn btn-primary"
                                type="button">
                            Save
                        </Button>

                    </Col>
                </Row>
                <RemoveModalDialog
                    show={this.state.removeRecordModalVisible}
                    removeRecord={(e) => this.deleteServiceArea() }
                    closeModal={(e) => this.setState({currentItemID: false, removeRecordModalVisible: false})}>
                </RemoveModalDialog>

            </div>);


    }
}

function mapStateToProps(state, props) {
    return {
        userReducer: state.userReducer
    };
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({makeRequest, displayMessage}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ServiceAreasSettingsPage);
